<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Backdrop (mobile) -->
<div
	*ngIf="isScreenSmall() && opened()"
	class="fixed inset-0 z-40 bg-black/40 print:hidden"
	(click)="closeNavigation()"
	(keydown)="closeNavigation()"
></div>

<!-- Navigation -->
<nav
	class="dark flex w-[235px] flex-none flex-col overflow-y-auto bg-primary-500 print:hidden"
	[ngClass]="{
		hidden: !opened(),
		'fixed inset-y-0 left-0 z-50 shadow-2xl': isScreenSmall()
	}"
>
	<!-- Logo -->
	<div class="flex h-10 flex-none flex-row items-center bg-white pl-3">
		<img
			class="h-8 w-auto drop-shadow-md"
			src="./assets/logo/TWRX_logo_primary.svg"
			alt="TWRX logo"
		/>
	</div>

	<app-navigation [items]="navigationItems | async"></app-navigation>
</nav>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
	<!-- Header -->
	<div class="relative z-49 flex h-10 w-full flex-0 items-center bg-white pl-3 pr-4 shadow print:hidden">
		<!-- Navigation toggle button -->
		<button
			mat-icon-button
			(click)="toggleNavigation()"
		>
			<mat-icon
				fontSet="fas"
				fontIcon="fa-bars"
				class="text-xl"
			></mat-icon>
		</button>

		<!-- Logo -->
		<div class="h-10 bg-white pl-1 pt-2">
			<img
				*ngIf="!opened()"
				@fadeInLeft
				class="w-24 drop-shadow-md"
				src="./assets/logo/TWRX_logo_primary.svg"
				alt="TWRX logo"
			/>
		</div>

		<!-- Menu -->
		<div class="ml-auto flex flex-row gap-x-2 pl-2">
			<!-- User Generated Files -->
			<app-generated-files></app-generated-files>

			<!-- User Notifications -->
			<app-user-notifications></app-user-notifications>

			<!-- User Profile -->
			<app-profile></app-profile>
		</div>
	</div>

	<!-- Content -->
	<div class="flex flex-auto flex-col">
		<router-outlet *ngIf="true"></router-outlet>
	</div>
</div>
